import moment from 'moment';
import queryString from 'query-string';
import { getHeader, getHeaderIdPositiva, getHeaderRotasAbertas } from '../auth/authManager';
import http from '../common/http';
import { responseHandler } from '../common/responseHandler';
import env from '../envConfig';
import { IdentificacaoPositivaModel } from '../model/IdentificacaoPositiva';
import { PessoaModel } from '../model/Pessoa';

export const obterInformacoesDetalhadasPessoa = async (identificador: number) => {
  const url = env.urlApi + `/transacional-api/v1/pessoa/${identificador}/informacoes-detalhadas`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterResponsaveisFamiliares = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/pessoa/${numeroFamiliar}/responsavel-familiar`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterRepresentanteLegal = async (numeroFamiliar: number) => {
  const url = env.urlApi + `/transacional-api/v1/pessoa/${numeroFamiliar}/representante-legal`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const verificarIdentificacaoPositiva = async (
  identificacaoPositiva: IdentificacaoPositivaModel
) => {
  const url = env.urlApi + `/transacional-api/v1/pessoa/identificacao-positiva`;
  const headers = getHeader({
    Accept: 'text/pdf,application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  });

  let formatedData = queryString.stringify(identificacaoPositiva);
  const response = await http.post(url, formatedData, { headers });
  return responseHandler(response);
};

export const obterDadosFamiliaPorPessoa = async (identificador: number) => {
  const url = env.urlApi + `/transacional-api/v1/pessoa/${identificador}/dados-familia`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosFamiliaPorPessoaIdPositiva = async (identificador: number) => {
  let url = env.urlApi + `/transacional-api/v1/pessoa/${identificador}/dados-familia`;
  const headers = getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosFamiliaPorPessoaRL = async (
  identificador: number,
  representanteLegal: boolean = false
) => {
  let url = env.urlApi + `/transacional-api/v1/pessoa/${identificador}/dados-familia-rl?`;
  url += `representanteLegal=${representanteLegal}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosFamiliaPorPessoaRLIdPositiva = async (
  identificador: number,
  representanteLegal: boolean = false
) => {
  let url = env.urlApi + `/transacional-api/v1/pessoa/${identificador}/dados-familia-rl?`;
  url += `representanteLegal=${representanteLegal}`;
  const headers = getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterPerfisPorCpf = async (cpf: string) => {
  if (cpf && cpf.trim() !== "" && cpf !== "null") {
    const url = env.urlApi + `/transacional-api/v1/pessoa/${cpf}/tipos-perfil`;
    const headers = getHeader();
    const response = await http.get(url, { headers });
    return responseHandler(response);
  }
};

export const obterPerfisIdPositiva = async (pessoa: PessoaModel) => {
  let url = env.urlApi + `/transacional-api/v1/pessoa/tipos-perfil/identificacao-positiva?`;
  url += `dataNascimento=${moment(pessoa.dataNascimento).format('DD-MM-YYYY')}&`
  url += `nomeCompleto=${pessoa.nomePessoa}&`
  url += `nomeDaMae=${pessoa.nomeDaMae}&`;
  url += `codigoUfIbge=${pessoa.codigoUfIbge}&`;
  url += `codigoMunicipioIbge=${pessoa.codigoMunicipioIbge}`;
  const headers = getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const verificarUsuarioCadUnico = async (dados: any) => {

  let url = env.urlApi + `/transacional-api/v1/pessoa/${dados.cpf}/cadunico?`;
  url += `dataNascimento=${moment(dados.dataNascimento).format('DD-MM-YYYY')}&`;
  url += `captchaResponse=${dados.passCode}`;

  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterInformacaoPeriodoRetornoCadastramento = async (identificador: string) => {
  const url = env.urlApi + `/transacional-api/v1/pessoa/periodo-retorno-cadastramento/${identificador}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
